import Immutable from "immutable";

const modalState = Immutable.Map({
  isUnClosable: false
});


export const modalOpenState = (state = modalState, action) => {
  switch (action.type) {
    case "MODAL_KEEP_OPEN":

      return state.set("isUnClosable", true);
    default:
      return state;
  }
};
